// extracted by mini-css-extract-plugin
module.exports = {"menuPanel":"MenuPanel_menuPanel__26TQk","backIcon":"MenuPanel_backIcon__2dFCX","backButton":"MenuPanel_backButton__26YyM"};